import { render, staticRenderFns } from "./PICMonitor.vue?vue&type=template&id=64228c0e&"
import script from "./PICMonitor.vue?vue&type=script&lang=js&"
export * from "./PICMonitor.vue?vue&type=script&lang=js&"
import style0 from "./PICMonitor.vue?vue&type=style&index=0&id=64228c0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports